import { InputFieldProps } from "@bleu.builders/ui";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useLoaderData } from "react-router";

import { CPFCNPJField } from "#/components/CPFCNPJField";
import { PhoneField } from "#/components/PhoneField";
import { SettingsCard } from "#/components/SettingsCard";
import { FieldsLoaderData } from "#/pages/(components)/types";
import { fetchZipCodeAddress } from "#/utils/fetchZipCodeAddress";

const fields = [
  {
    name: "name",
    label: "Nome fantasia",
    description: "Digite o nome fantasia da sua empresa.",
    type: "input",
  },
  {
    name: "cpf_cnpj",
    label: "CPF/CNPJ",
    description: "Digite seu CPF ou o CNPJ da sua empresa.",
    type: "cpfcnpj",
    mode: "text",
  },
  {
    name: "email",
    label: "Email de Cobrança",
    description:
      "Digite o email para onde vamos enviar as Notas Fiscais emitidas pela ClickFiscal.",
    type: "input",
  },
  {
    name: "phone_number",
    label: "Telefone",
    type: "phone_number",
    mode: "text",
  },
  {
    name: "zip_code",
    label: "CEP",
    type: "input",
    mode: "text",
  },
  {
    name: "address",
    label: "Logradouro",
    type: "input",
    mode: "text",
  },
  {
    name: "complement",
    label: "Complemento",
    type: "input",
    mode: "text",
  },
  {
    name: "city",
    label: "Cidade",
    type: "input",
    mode: "text",
  },
  {
    name: "state",
    label: "Estado",
    type: "select",
    options: [
      { value: "AC", label: "Acre" },
      { value: "AL", label: "Alagoas" },
      { value: "AP", label: "Amapá" },
      { value: "AM", label: "Amazonas" },
      { value: "BA", label: "Bahia" },
      { value: "CE", label: "Ceará" },
      { value: "DF", label: "Distrito Federal" },
      { value: "ES", label: "Espírito Santo" },
      { value: "GO", label: "Goiás" },
      { value: "MA", label: "Maranhão" },
      { value: "MT", label: "Mato Grosso" },
      { value: "MS", label: "Mato Grosso do Sul" },
      { value: "MG", label: "Minas Gerais" },
      { value: "PA", label: "Pará" },
      { value: "PB", label: "Paraíba" },
      { value: "PR", label: "Paraná" },
      { value: "PE", label: "Pernambuco" },
      { value: "PI", label: "Piauí" },
      { value: "RJ", label: "Rio de Janeiro" },
      { value: "RN", label: "Rio Grande do Norte" },
      { value: "RS", label: "Rio Grande do Sul" },
      { value: "RO", label: "Rondônia" },
      { value: "RR", label: "Roraima" },
      { value: "SC", label: "Santa Catarina" },
      { value: "SP", label: "São Paulo" },
      { value: "SE", label: "Sergipe" },
      { value: "TO", label: "Tocantins" },
    ],
  },
] as InputFieldProps[];

export default function OrganizationSettingsPage() {
  const { data } = useLoaderData() as FieldsLoaderData;

  const form = useForm({
    defaultValues: data?.defaultValues,
  });
  const zip = form.watch("zip_code");

  useEffect(() => {
    fetchZipCodeAddress(zip).then((data) => {
      if (!data) {
        return;
      }

      Object.entries(data).forEach(([key, value]) => {
        form.setValue(key, value);
      });
    });
  }, [zip]);

  return (
    <>
      <div className="my-8 space-y-4">
        <SettingsCard
          title="Informações de Cobrança"
          defaultValues={data?.defaultValues}
          fields={fields}
          formReturn={form}
          action={{ path: "/organizations/1" }}
          customComponents={{
            phone_number: PhoneField,
            cpfcnpj: CPFCNPJField,
          }}
        />
      </div>
    </>
  );
}
